import translator from "@/translator";
import React, { useState } from "react";
import { Card } from "antd";
import BackButton from "@/note_office/shared/BackButton";
import { EditOutlined } from "@ant-design/icons";

const t = translator("note_office.views.notifications.index_view.");

const IndexView = ({ notificationData }) => {
  const { bookings_menu_url, notifications } = notificationData || {};
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);

  const handleEdit = (notification) => {
    window.location.href = notification.edit_url;
  };

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <BackButton link={bookings_menu_url} text={t("title")} />

      <div className="bulk_deliveries__card-container overflow">
        {notifications.map((notification) => (
          <Card
            key={notification.id}
            className={`bulk_deliveries__card ${selectedNotificationId === notification.id ? "selected-template" : ""}`}
            onClick={() => {
              if (selectedNotificationId === notification.id) {
                handleEdit(notification);
              } else {
                setSelectedNotificationId(notification.id);
              }
            }}
          >
            <div
              className="bulk_deliveries__edit-icon"
              onClick={() => {
                handleEdit(notification);
              }}
            >
              <EditOutlined style={{ fontSize: "20px" }} />
            </div>

            <div className="bulk_deliveries__details-template">
              <span className="bulk_deliveries__label">{t("time_label")}:</span>
              <span className="bulk_deliveries__text">
                {t(`time_phrases.${notification.notification_type}`)}
              </span>
            </div>

            <div className="bulk_deliveries__details-template">
              <span className="bulk_deliveries__label">{t("type_label")}:</span>
              <span className="bulk_deliveries__text">
                {t(`types_phrases.${notification.notification_type}`)}
              </span>
            </div>

            <div className="bulk_deliveries__details-template bulk_deliveries__details-last">
              <span className="bulk_deliveries__label">{t("text_label")}:</span>
              <span className="bulk_deliveries__fulltext">{notification.body}</span>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default IndexView;
